import OrganizationIntegration from "./OrganizationIntegration";

export default OrganizationIntegration;
